module.exports = __webpack_public_path__ + "media/application/images/2018/twitter-blue@2x-9e413fdf06f218eaf0f8c6cb4b88e16b.png";